import axiosClient, { ApiResponse, axiosCustomError } from "./axiosClient"
import { ILanguage } from "./LanguageService"

export interface ITicketTranslation {
    ticketId: number | null
    languageId: number
    name: string
    description: string
    language: ILanguage
}

export interface ITicket {
    id: number | null
    name: string
    orderNumber: number | null
    isUsed: boolean
    placeId: number
    translations: Array<ITicketTranslation>
}

export default class TicketService {
    static async listAll(placeId: number) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/Tickets/${placeId}/All`)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async filter(placeId: number, pageIndex: number, pageSize: number, keyword: string) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/Tickets/${placeId}?keyword=${keyword}&pageSize=${pageSize}&pageIndex=${pageIndex}`)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async get(placeId: number, id: number) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/Tickets/${placeId}/${id}`)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async delete(placeId: number, id: number) {
        try {
            const { data } = await axiosClient.delete<ApiResponse>(`/api/Tickets/${placeId}/${id}`, {

            })

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async update(placeId: number, id: number, itemData: ITicket) {
        try {
            const { data } = await axiosClient.put<ApiResponse>(`/api/Tickets/${placeId}/${id}`, itemData)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async create(placeId: number, itemData: ITicket) {
        try {
            const { data } = await axiosClient.post<ApiResponse>(`/api/Tickets/${placeId}/Create`, itemData)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async changeIsUsed(placeId: number, id: number) {
        try {
            const { data } = await axiosClient.put<ApiResponse>(`/api/Tickets/${placeId}/ChangeIsUsed/${id}`)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }
}